if (!window.__signadoxEmbeddingLiveDemosBound) {
  window.__signadoxEmbeddingLiveDemosBound = true

function appendFromTemplate (slotId, templateId, sectionId) {
  if (document.getElementById(sectionId)) return document.getElementById(sectionId)

  const slot = document.getElementById(slotId)
  const template = document.getElementById(templateId)
  if (!slot || !template) return null

  slot.appendChild(template.content.cloneNode(true))
  return document.getElementById(sectionId)
}

function mountSigningDemo (btn) {
  const tab = document.getElementById('embedding_signing_form')
  if (tab?.classList.contains('hidden')) return

  const target = appendFromTemplate('live_example_slot', 'live_example_template', 'live_example')
  const mountEl = target?.querySelector('[data-live-example-mount]')
  if (!target || !mountEl) return

  const src = btn.getAttribute('data-demo-src')
  if (!src) {
    mountEl.innerHTML = '<div class="p-8 text-warning">Sample document could not be prepared. Check server logs and try again.</div>'
    target.scrollIntoView({ behavior: 'smooth', block: 'start' })
    return
  }

  if (!mountEl.querySelector('iframe')) {
    const iframe = document.createElement('iframe')
    iframe.title = 'Signing form live example'
    iframe.src = src
    iframe.allow = 'geolocation; microphone; camera'
    iframe.setAttribute('class', 'w-full min-h-[720px] h-[80vh] border-0 bg-base-100')
    mountEl.replaceChildren(iframe)
  }

  target.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

function mountBuilderDemo () {
  const tab = document.getElementById('embedding_form_builder')
  if (tab?.classList.contains('hidden')) return

  const section = appendFromTemplate('builder_live_example_slot', 'builder_live_example_template', 'builder_live_example')
  const root = document.getElementById('builder_live_demo_root')
  const mountEl = document.getElementById('builder_live_demo_mount')
  if (!section || !root || !mountEl) return

  initBuilderDemoToggles(root)

  const editUrl = root.getAttribute('data-edit-url')
  if (!editUrl) {
    mountEl.innerHTML = '<div class="p-8 text-warning">Builder sample document could not be prepared. Check server logs and try again.</div>'
    section.scrollIntoView({ behavior: 'smooth', block: 'start' })
    return
  }

  if (!mountEl.querySelector('iframe')) {
    const iframe = document.createElement('iframe')
    iframe.title = 'Form builder live example'
    iframe.src = editUrl
    iframe.setAttribute('class', 'w-full min-h-[720px] h-[80vh] border-0 bg-[#faf7f5]')
    mountEl.replaceChildren(iframe)
  }

  section.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

function initBuilderDemoToggles (root) {
  if (!(root instanceof Element)) {
    root = document.getElementById('builder_live_demo_root')
  }

  if (!root || root.dataset.togglesBound === 'true') return

  root.dataset.togglesBound = 'true'

  root.querySelectorAll('[data-toggle]').forEach((toggle) => {
    toggle.addEventListener('change', () => mountBuilderDemo())
  })
}

document.addEventListener('click', (event) => {
  const signingBtn = event.target.closest('#open_signing_live_demo')
  if (signingBtn) {
    event.preventDefault()
    mountSigningDemo(signingBtn)
    return
  }

  const builderBtn = event.target.closest('#open_builder_live_demo')
  if (builderBtn) {
    event.preventDefault()
    mountBuilderDemo()
  }
}, true)

document.addEventListener('turbo:load', () => initBuilderDemoToggles())
document.addEventListener('DOMContentLoaded', () => initBuilderDemoToggles())

document.addEventListener('turbo:before-cache', () => {
  const root = document.getElementById('builder_live_demo_root')
  if (root) delete root.dataset.togglesBound
})
}
